import { ApiResult, FileDetails } from 'common/models';
import { HttpClient } from 'common/services/http-client.service';

import fileUploadConfig from './fileUpload.config';
import { SyncDetails, UploadFileDetails } from 'common/models/data/fileUpload.model';

export class FileUploadService extends HttpClient {
    public static async uploadFile(
        payload: FileDetails,
        onProgress: (event: any) => void,
        variantName: string,
        targetId: string,
        entityType: string
    ): Promise<ApiResult<unknown> | undefined> {
        const header = {
            'content-type': 'multipart/form-data'
        };
        const additionalConfig = {
            onUploadProgress: onProgress
        };
        const formData = new FormData();
        formData.append('file', payload);
        return await this.invokeApi(
            fileUploadConfig.uploadFile(
                formData,
                header,
                additionalConfig,
                variantName,
                targetId,
                entityType
            )
        );
    }

    public static async getSyncDetails(): Promise<ApiResult<SyncDetails> | undefined> {
        return await this.invokeApi(fileUploadConfig.getSyncDetails());
    }

    public static async fetchUploadStatus(): Promise<ApiResult<UploadFileDetails> | undefined> {
        return this.invokeApi(fileUploadConfig.fetchUploadStatus());
    }
}
